<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						地下城
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title">
					地下城
				</h3>
				<table class="table table-bordered dungeon-table" style="min-width: 800px">
					<thead>
						<th width="15%">地城名稱</th>
						<th>地城幣數量</th>
						<th>過關獎勵</th>
						<th>開啟條件</th>
					</thead>
					<tbody>
						<tr>
							<td>
								雲海山脈
								<br>(NORMAL)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 100
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：6</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 100
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：7</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 100
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 200
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約6萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約12萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								雲海的魔物肉 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 2-12
							</td>
						</tr>
						<tr>
							<td>
								密林大樹
								<br>(HARD)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 200
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：6</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 200
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：9</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 200
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：10</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 200
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 600
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約28萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 800
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約34萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								密林的果實<br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 5-13
							</td>
						</tr>
						<tr>
							<td>
								斷崖遺跡
								<br>(VERY HARD)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：5</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：7</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：9</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：10</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1200
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約60萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1500
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約72.6萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>								
								斷崖的小點 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 7-14
							</td>
						</tr>
						<tr>
							<td>
								蒼海孤塔
								<br>(EXTREME)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：1</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 400
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：2</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 400
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 400
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：4</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 400
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：5</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 400
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1600
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約72萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 2000
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約92萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								蒼海的淡雪糖 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 11-17
							</td>
						</tr>
						<tr>
							<td>
								毒瘴闇稜
								<br>(EXTREME II)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：1</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 500
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：2</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 500
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 600
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：4</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 600
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：5</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 300
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 2200
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約116萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 2500
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約146萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								絕世好蛋與海量飯山 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 14-14
							</td>
						</tr>
						<tr>
							<td>
								綠龍骸嶺
								<br>(EXTREME III)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：1</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 600
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：2</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 600
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 800
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：4</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 800
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：5</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 400
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 2800
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約160萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 3200
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約203萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								極上龍尾關東煮 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 26-14
							</td>
						</tr>
						<tr>
							<td>
								天上浮城
								<br>(EXTREME 4)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：1</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 700
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：2</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 700
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1000
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：4</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1000
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：5</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 500
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 3400
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約260萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 3900
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約331萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								天露の金甘水 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 35-14
							</td>
						</tr>
						<tr>
							<td>
								砂瀑底都
								<br>(EXTREME 5)
							</td>
							<td>
								<ul class="list-group list-group-flush">
									<li class="list-group-item">
										<span class="floor_num">樓層：1</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 800
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：2</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 800
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：3</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1200
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：4</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 1200
									</li>
									<li class="list-group-item">
										<span class="floor_num">樓層：5</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 600
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐前共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 4000
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約360萬
									</li>
									<li class="list-group-item">
										<span class="floor_num">討伐後共：</span>
										<img width="30" src="/static/images/item/icon_item_90002.png" alt="地下城幣" class="img-fluid ml-4"> x 4600
										<img width="20" src="/static/images/mana.png" alt="mana" class="img-fluid ml-4"> x 約455萬
									</li>
								</ul>
							</td>
							<td>
								家具 <br>
								大地仙人掌蜂蜜鬆餅 <br>
								可以6小時生產體力x12，保管上限到48為止。
							</td>
							<td>
								NORMAL 47-14
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Dungeon',
	data() {
		return {}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '地下城',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。' }
		]
	},
	methods: {},
	computed: {

	},
	mounted: function() {

	}
}

</script>
<style scoped>
</style>
